import React from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import DataItem from '../dataItem';

const StatsSectionContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
}));

const StatsRow = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
    alignSelf: 'stretch',
}));

const StatItem = styled(Box)(({ theme, hasBorder = false }) => ({
    display: 'flex',
    paddingRight: '10px',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '5px',
}));

const StatsSection = ({
    stats = null,
    activeView = 'week',
    isRangeData = false,
    type = null, // step, heartbeat, didim, 
    ...props
}) => {
    const theme = useTheme();
    const { t } = useTranslation();

    if (!stats) {
        return null;
    }

    const dataItemLabelSx = {
        width: '70px',
        textAlign: 'left',
    };

    const dataItemSx = {
        paddingRight: '10px',
        display: 'flex',
        alignItems: 'center',
        flex: 1,
    };

    return (
        <StatsSectionContainer {...props}>

            {/* 첫 번째 행 - 평균 */}
            <StatsRow>
                {type !== 'didim' && (
                    <DataItem
                        label={t('average')}
                        value={stats.distance || '-'}
                        unit="km"
                        size="medium"
                        labelSx={dataItemLabelSx}
                        valueSx={{
                            textAlign: 'left',
                        }}
                        sx={{
                            borderRight: `1px solid ${theme.palette.figma.white[20]}`,
                            gap: '0px',
                            justifyContent: 'left',
                            ...dataItemSx
                        }}
                    />
                )}
                <DataItem
                    value={stats.calories || '-'}
                    unit="kcal"
                    size="medium"
                    sx={{
                        justifyContent: type === 'didim' ? 'left' : 'center',
                        borderRight: type !== 'didim' ? `1px solid ${theme.palette.figma.white[20]}` : 'none',
                        gap: '5px',
                        ...dataItemSx
                    }}
                />
                {type !== 'didim' && (
                    <DataItem
                        value={stats.floors || '-'}
                        unit={t('floors')}
                        size="medium"
                        sx={{
                            gap: '5px',
                            justifyContent: 'center',
                            ...dataItemSx
                        }}
                    />)}
            </StatsRow>

            {/* 두 번째 행 - 총 디딤 */}
            <StatsRow>
                <StatItem>
                    <DataItem
                        label={t('total_didim')}
                        value={stats.totalSteps}
                        size="medium"
                        labelSx={dataItemLabelSx}
                        sx={{ justifyContent: "space-between" }}
                    />
                </StatItem>
            </StatsRow>

            {/* 세 번째 행 - 목표 달성한 날 */}
            {type !== 'didim' && (<StatsRow>
                <StatItem>
                    <DataItem
                        label={t('goal_achieved_days')}
                        value={stats.goalDays || '-'}
                        unit={'/ ' + stats.totalDays}
                        size="medium"
                        labelSx={dataItemLabelSx}
                        sx={{ justifyContent: "space-between" }}
                    />
                </StatItem>
            </StatsRow>)}

            {/* 연간차트 추가 통계 - 가장 많이/적게 걸은 날 (범위 데이터가 아닌 경우만) */}
            {activeView === 'year' && !isRangeData && stats.bestDay && stats.worstDay ? (
                <>
                    <StatsRow>
                        <StatItem>
                            <DataItem
                                label={t('day_with_most_steps')}
                                value={stats.bestDay}
                                size="small"
                                sx={{ justifyContent: "space-between", gap: '5px', padding: '2px 0' }}
                            />
                        </StatItem>
                    </StatsRow>
                    <StatsRow>
                        <StatItem>
                            <DataItem
                                label={t('day_with_fewest_steps')}
                                value={stats.worstDay}
                                size="small"
                                sx={{ justifyContent: "space-between", gap: '5px', padding: '2px 0' }}
                            />
                        </StatItem>
                    </StatsRow>
                </>
            ) : (<></>)}
        </StatsSectionContainer>
    );
};

export default StatsSection;
